interface DropdownMenuProps {
  children: React.ReactNode
  className?: string
  anchor?: string
}

export default function DropdownMenu({
 children, className = '', anchor = 'bottom end' 
}: DropdownMenuProps) {
  const baseClasses = "absolute z-50 mt-2 w-56 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
  
  return (
    <div className={`${baseClasses} ${className}`} data-anchor={anchor}>
      {children}
    </div>
  )
} 